import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {selectUser} from './redux/slices/user';
import Dashboard from './pages/dashboard/Main';
import TerminosCondiciones from './pages/terminos_condiciones/Main';
import Login from './pages/login/Main';
import MapaRutaUI from './pages/monitor/components/MapaRuta';

const App = () => {
  const user = useSelector(selectUser);
  return (
    <Router>
      <Routes>
        <Route path="/*" element={user ? <Dashboard /> : <Login />} />
        <Route path="/privacy_policy" element={<TerminosCondiciones />} />
      </Routes>
    </Router>
  );
}

export default App;
